import React from 'react'
import GameItem from '../GameList/GameItem'
import ViewRequestModal from '../Modals/ViewRequestModal'
import 'whatwg-fetch'

class Friends extends React.Component {
  constructor (props) {
    super(props)

    this.state = { friends: [], requests: [], loadingF: true, loadingR: true }
  }

  componentWillMount () {
    const { baseUrl } = this.props
    fetch(`${baseUrl}/user/friends`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          this.setState({ friends: res.friends })
        } else {
          alert('Error: ' + res.err)
        }
      })
      .catch(err => console.log('err: ', err))
      .then(() => this.setState({ loadingF: false }))

    fetch(`${baseUrl}/user/friend_requests`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          this.setState({ requests: res.requests })
        } else {
          alert('Error: ' + res.err)
        }
      })
      .catch(err => console.log('err: ', err))
      .then(() => this.setState({ loadingR: false }))
  }

  renderFriend (friend) {
    return (<GameItem key={friend.id} second={friend.name} third='' onClick={() => window.location.href=`/profile/${friend.name}`} />)
  }

  renderRequest (request) {
    const { openViewRequestModal } = this.props
    return (<GameItem key={request.id} second={request.name} third='' onClick={() => openViewRequestModal(request)} />)
  }

  render () {
    const { friends, loadingF, loadingR, requests } = this.state
    const { baseUrl, viewRequestModal, closeViewRequestModal } = this.props
    return (
      <div>
        { viewRequestModal && <ViewRequestModal baseUrl={baseUrl} closeViewRequestModal={closeViewRequestModal} request={viewRequestModal} />}
        <h4 style={{fontSize: '24px', marginTop: '1em', marginBottom: '0.3em'}}>Friends</h4>
        <div>
        { loadingF && <div>Loading..</div> }
        { !loadingF && !friends.length && <div>No friends :(</div>}
        { friends.length > 0 && <ul>{friends.map(f => this.renderFriend(f))}</ul>}
        </div>
        <h4 style={{fontSize: '24px', marginTop: '1em', marginBottom: '0.3em'}}>Friend Requests</h4>
        <div>
        { loadingR && <div>Loading..</div> }
        { !loadingR && !requests.length && <div>No requests :(</div>}
        { requests.length > 0 && <ul>{requests.map(f => this.renderRequest(f))}</ul>}
        </div>
      </div>
    )
  }
}

export default Friends



/** WEBPACK FOOTER **
 ** ./src/components/Friends/Friends.js
 **/